<template>
    <div>
       <el-dialog
            title="选择菜品"
            :visible.sync="dishesDialog"
            width="800px"
            :before-close="handleClose">
            <el-row style="border-bottom: 1px solid #e8e8e8;padding:16px 24px;">
                <el-form>
                    <el-col :span="18">
                 <el-input @input="searchData" v-model="searchValue" placeholder="请输入菜品名或助记码搜索">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-col>
                </el-form>
            </el-row>
            <el-row style="height:300px;">
                <el-col :span="6" style="height:100%;overflow:scroll;padding:10px 5px;">
                    <div :class="categoryIndex==index ? 'activeItem':'categoryItem' " v-for="(item,index) in categoryTreeDate" :key="index" @click="selectCategory(item,index)">{{item.categoryName}}</div>   
                </el-col>
                <el-col :span="18"  style="height:100%;overflow:scroll;">
                    <el-table :data="tableData" v-loading="tableLoading"
                     element-loading-background="rgba(255, 255, 255, 1)"
                    :row-key="row => {return row.productCode}" 
                    style="width: 100%" height="300" ref="multipleTable"
                    @selection-change="handleSelectionChange" >
                        <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
                        <el-table-column prop="productName" label="菜品名称" align="center"></el-table-column>
                        <el-table-column prop="normalPrice" label="价格" align="center"></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row class="selectBox">
                <el-col :span="24" class="hasSelectBox">
                    <div>已选择({{selectList.length}})</div>
                    <div class="select" @click="clearCategoryAll">清空</div>
                </el-col>
                <el-col :span="24" style="padding-top:5px;height:50px;max-height:150px;overflow:scroll;">
                  <el-tag type="info" class="mr5" @close='delSelect(item)' closable v-for="(item,index) in selectList" :key="index">{{item.productName}}</el-tag>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button class="cancel" @click="handleClose">取 消</el-button>
                <el-button type="primary" class="sumbit" @click="confirm">确 定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
export default {
    data(){
        return {
           tableLoading:true,
           dishesDialog:false,
           searchValue:'',
           categoryTreeDate:[],
           categoryIndex:'0',
           tableData:[],
           selectCategoryCode:'',
           selectList:[],
           dishesList:[],
           type:'',
           search:{merchantCode:localStorage.getItem('merchantCode'),categoryCode:''}
        }
    },
    props:{
        dishesDialogVisible:{
            type: Boolean,
            default:false,
        },
        defoultSelect:{
           type: Array,
           default:false,
        },
        selectType:{
          type: String,
           default:false,
        }
     },
     watch:{
      'dishesDialogVisible':{
        deep:true,
     async handler(v){
      this.selectList=this.defoultSelect
        this.dishesDialog=v
          if(v){
            this.tableLoading=true
        this.getCatogaryList()
     await  this.getTable()
     this.toggle()
     setTimeout(()=>{
      this.tableLoading=false
     },400)
          }
        }
      },
      'defoultSelect':{
        handler(v){
          this.selectList=JSON.parse(JSON.stringify(this.defoultSelect))
          console.log(v,'defoultSELECT')
        }
      },
      'selectType':{
        handler(v){
          this.type=v
        }
      }
     },
     mounted(){
        // this.getDishes()
     },
     methods:{
      searchData(){
        this.search.productName=this.searchValue
        let time=setTimeout(()=>{
          if(time){
            clearTimeout(time)
          }
          this.getTable()
        },400)
      },
      selectCategory(item,index){
        this.categoryIndex=index
        this.search.categoryCode=item.categoryCode
        this.getTable()
      },
   //查询菜品分类接口
 async  getCatogaryList(){
      let data = {}
      data.merchantCode = localStorage.getItem('merchantCode')
      let res=await this.$http.post('/merchantProductsCategory/queryList',data)
      this.categoryTreeDate=res.data.data
      this.categoryTreeDate.unshift({categoryName:'全部',categoryCode:''})
    },
    async getTable(){
      let res=await this.$http.post('/merchantProducts/queryList',this.search)
      this.tableData=res.data.data
      return res
    },
        handleClose(){
             this.$emit('handleDishesClose',false,this.selectList,this.type)
             this.dishesDialog = false
        },
          handleSelectionChange(v){
          this.selectList=v
          console.log(v,'选择变化')
        },
        confirm(){ //确定按钮
        console.log('//确定按钮')
         this.$emit('handleDishesClose',false,this.selectList,this.type)
           this.dishesDialog = false
        },
        // 清空
        clearCategoryAll(){
           this.$refs.multipleTable.clearSelection();
        },
        delSelect(obj){
        let raw= this.tableData.find(item=>{
            return item.productCode===obj.productCode
          })
          console.log(raw,obj)
          this.$refs.multipleTable.toggleRowSelection(raw,false)
        },
        toggle(){
          let arr=this.defoultSelect
          let need=[]
          this.$refs.multipleTable.clearSelection()
          this.tableData.forEach(item=>{
            arr.forEach(e=>{
              if(item.productCode===e.productCode){
                need.push(item)
              }
            })
          })
          need.forEach(i=>{
            this.$refs.multipleTable.toggleRowSelection(i,true)
          })
        }

     }
}
</script>

<style lang="less" scoped>

   .sumbit {
    background-color: #ffbd00;
    border: none;
    color: #000;
  }
  .sumbit:hover {
    opacity: 0.8;
  }
  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
  .categoryItem{
    width:80%;
    padding: 5px;
    margin: 0 auto;
    border-radius: 3px;
  }
  .categoryItem:hover{
     background: rgb(247,247,247);
     cursor: pointer;
  }
  .activeItem{
    background: rgba(255,189,0,.2);
    width:80%;
    padding: 5px;
    margin: 0 auto;
    border-radius: 3px;
    cursor: pointer;
  }
  /deep/ .el-dialog__header{
    border-bottom: 1px solid #e8e8e8;
  }
  /deep/ .el-dialog__body{
    padding: 0;
  }
  /deep/ .el-dialog__footer{
    border-top: 1px solid #e8e8e8;
  }
  /deep/ .el-table{
    margin-top: 0;
  }
.hasSelectBox{
   display: flex;
   justify-content: space-between;
   margin-top: 10px;
}
.selectBox{
  padding: 24px;
}
.select {
   color: #ff6000;
   cursor: pointer;
 }
 .mr5{
    margin-right: 5px;
    margin-bottom: 5px;
 }
</style>